module.exports = __webpack_public_path__ + "img/lastStep.a0313f1d.png";